import { type NodeProps, Position } from '@xyflow/react';
import EditIcon from '@mui/icons-material/Edit';

import type { NodeItem, ParentNode, DataItems } from '@models/flows';
import { Connector } from '@utils/flows';

import { useNodeError } from '@hooks/useNodeError';

import {
  ConnectionPoint,
  DeleteButton,
  ErrorToolTip,
} from '@components/Flows/components/partials/index';

import { initialFailureNodeData } from '@features/chargerFlows/validation/validation-helpers';

import s from './FailureNode.module.css';

type FailureNodeProps = NodeProps & {
  onEdit: (parentNode: ParentNode, childNode: NodeItem) => void;
  onDelete: (nodeId: string) => void;
};

function FailureNode({ id, type, data, onEdit, onDelete }: FailureNodeProps) {
  const failureNodeData = data as unknown as DataItems;
  const nodeItems = failureNodeData?.items || [initialFailureNodeData];
  const parentNode: ParentNode = {
    id,
    type,
    data: failureNodeData,
  };
  const failureNodeItem = nodeItems[0];
  const errors = useNodeError(id);

  const handleEdit = () => {
    onEdit(parentNode, failureNodeItem);
  };

  const v = failureNodeItem.value;
  const hasDecreasePercent = v !== '' && v != null && !(typeof v === 'number' && Number.isNaN(v));
  const displayValue = hasDecreasePercent ? `${String(v)}%` : 'No value set';

  return (
    <div className={`${s.container} ${errors ? s.errorBorder : ''}`}>
      <h1 className={s.title}>Failure Node</h1>
      <ErrorToolTip isErrorVisible={Boolean(errors)} messages={errors?.messages} />
      <DeleteButton onDelete={() => onDelete(id)} />
      <div className={s.valueBlock}>
        <div className={s.valueContent}>
          <span className={s.typeTag}>Number</span>
          <p className={s.valueLabel}>{displayValue}</p>
        </div>
        <button type="button" className={s.editButton} onClick={handleEdit}>
          <EditIcon />
        </button>
      </div>
      <ConnectionPoint type={Connector.Target} position={Position.Left} id="incoming" />
    </div>
  );
}

export default FailureNode;
